(function () {
  var J = window.JM || {};
  var R = J.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fmt(c) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: J.currency || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function json(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }

  var toastT;
  function toast(msg) {
    var t = $('[data-jm-toast]'); if (!t) return;
    $('[data-jm-toast-text]', t).textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 2600);
  }

  function renderCart(cart) {
    $$('[data-jm-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
    var d = $('[data-jm-drawer]'); if (!d) return;
    var sub = cart.total_price, free = J.freeFrom || 0;
    var ship = sub === 0 || sub >= free ? 0 : (J.ship || 0);
    $('[data-jm-drawer-title]', d).textContent = 'Warenkorb (' + cart.item_count + ')';
    $('[data-jm-ship-msg]', d).textContent = sub >= free ? 'Dein Versand ist kostenlos.' : 'Noch ' + fmt(free - sub) + ' bis zum kostenlosen Versand';
    $('[data-jm-ship-bar]', d).style.width = Math.min(100, free ? sub / free * 100 : 100) + '%';
    var list = $('[data-jm-drawer-items]', d);
    if (!cart.items.length) {
      list.innerHTML = '<div class="jm-drawer__empty"><strong>Dein Warenkorb ist leer.</strong><button type="button" class="jm-btn jm-btn--ghost" data-jm-cart-close>Weiter einkaufen</button></div>';
    } else {
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy">' : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="jm-small jm-muted">' + esc(it.variant_title) + '</div>' : '';
        var k = esc(it.key);
        return '<div class="jm-line"><a href="' + esc(it.url) + '" class="jm-line__img">' + img + '</a>' +
          '<div class="jm-line__body"><a href="' + esc(it.url) + '" class="jm-line__title">' + esc(it.product_title) + '</a>' + variant +
          '<div class="jm-line__qty"><div class="jm-stepper jm-stepper--sm">' +
          '<button type="button" data-jm-line="' + k + '" data-q="' + (it.quantity - 1) + '" aria-label="Weniger">−</button><span>' + it.quantity + '</span>' +
          '<button type="button" data-jm-line="' + k + '" data-q="' + (it.quantity + 1) + '" aria-label="Mehr">+</button></div>' +
          '<button type="button" class="jm-link-muted" data-jm-line="' + k + '" data-q="0">Entfernen</button></div></div>' +
          '<div class="jm-line__price">' + fmt(it.final_line_price) + '</div></div>';
      }).join('');
    }
    $('[data-jm-subtotal]', d).textContent = fmt(sub);
    $('[data-jm-ship]', d).textContent = sub === 0 ? '–' : ship === 0 ? 'Kostenlos' : fmt(ship);
    $('[data-jm-total]', d).textContent = fmt(sub + ship);
    $('[data-jm-checkout]', d).hidden = !cart.items.length;
  }
  function refresh() { return json(R.cart + '.js').then(renderCart); }
  function openDrawer() {
    var d = $('[data-jm-drawer]'); if (!d) { location.href = R.cart; return; }
    refresh(); d.hidden = false; document.documentElement.classList.add('jm-lock');
  }
  function closeDrawer() { var d = $('[data-jm-drawer]'); if (d) d.hidden = true; document.documentElement.classList.remove('jm-lock'); }
  function add(id, qty, title) {
    return json(R.cartAdd + '.js', { items: [{ id: +id, quantity: qty || 1 }] })
      .then(function () { toast((title || 'Artikel') + ' liegt im Warenkorb'); return refresh(); })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Konnte nicht hinzugefügt werden.'); });
  }
  function change(key, q) { return json(R.cartChange + '.js', { id: key, quantity: Math.max(0, q) }).then(renderCart); }
  function closeSlots() { $$('[data-jm-slot].is-open').forEach(function (s) { s.classList.remove('is-open'); var b = $('[data-jm-slot-toggle]', s); if (b) b.setAttribute('aria-expanded', 'false'); }); }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-jm-add]'))) { e.preventDefault(); add(t.getAttribute('data-jm-add'), 1, t.getAttribute('data-title')); closeSlots(); return; }
    if ((t = e.target.closest('[data-jm-cart-open]'))) { e.preventDefault(); var ts = $('[data-jm-toast]'); if (ts) ts.hidden = true; openDrawer(); return; }
    if ((t = e.target.closest('[data-jm-cart-close]'))) { e.preventDefault(); closeDrawer(); return; }
    if ((t = e.target.closest('[data-jm-line]'))) { change(t.getAttribute('data-jm-line'), +t.getAttribute('data-q')); return; }
    if ((t = e.target.closest('[data-jm-step]'))) {
      var inp = t.parentNode.querySelector('input'); if (inp) inp.value = Math.max(1, (+inp.value || 1) + (+t.getAttribute('data-jm-step'))); return;
    }
    if ((t = e.target.closest('[data-jm-thumb]'))) {
      var img = $('[data-jm-main-media] img'); if (img) { img.removeAttribute('srcset'); img.src = t.getAttribute('data-jm-thumb'); } return;
    }
    if ((t = e.target.closest('[data-jm-slot-toggle]'))) {
      var s = t.closest('[data-jm-slot]'), was = s.classList.contains('is-open'); closeSlots();
      if (!was) { s.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); } return;
    }
    if (!e.target.closest('[data-jm-slot]')) closeSlots();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSlots(); closeDrawer(); } });

  $$('[data-jm-product-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = f.querySelector('[name="id"]').value, q = f.querySelector('[name="quantity"]');
      add(id, q ? Math.max(1, +q.value || 1) : 1, f.getAttribute('data-title'));
    });
  });
  $$('[data-jm-variant]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex], p = $('[data-jm-price]');
      if (p && o) p.textContent = o.getAttribute('data-price');
      try { var u = new URL(location.href); u.searchParams.set('variant', sel.value); history.replaceState(null, '', u.toString()); } catch (err) {}
    });
  });

  $$('[data-jm-catalog]').forEach(function (root) {
    var grid = $('[data-jm-grid]', root); if (!grid) return;
    var cards = $$('[data-jm-card]', grid);
    var st = { q: '', f: { land: [], kat: [], taste: [], diaet: [], extra: [] }, max: null, sort: 'beliebt' };
    var range = $('[data-jm-price]', root), out = $('[data-jm-price-out]', root), maxAll = range ? +range.max : Infinity;
    function has(c, attr, v) { return (' ' + (c.getAttribute(attr) || '') + ' ').indexOf(' ' + v + ' ') > -1; }
    var sorter = {
      beliebt: function (a, b) { return a.dataset.i - b.dataset.i; },
      neu: function (a, b) { return (b.dataset.new - a.dataset.new) || (a.dataset.i - b.dataset.i); },
      'preis-auf': function (a, b) { return a.dataset.price - b.dataset.price; },
      'preis-ab': function (a, b) { return b.dataset.price - a.dataset.price; }
    };
    function ok(c) {
      var q = st.q.trim().toLowerCase(), f = st.f, i, d;
      if (q && (c.getAttribute('data-search') || '').indexOf(q) < 0) return false;
      if (f.land.length && f.land.indexOf(c.dataset.land) < 0) return false;
      if (f.kat.length && f.kat.indexOf(c.dataset.kat) < 0) return false;
      if (f.taste.length && !f.taste.some(function (t) { return has(c, 'data-taste', t); })) return false;
      for (i = 0; i < f.diaet.length; i++) {
        d = f.diaet[i];
        if (d.indexOf('ohne-') === 0) { if (has(c, 'data-allergen', d.slice(5))) return false; }
        else if (!has(c, 'data-diaet', d)) return false;
      }
      if (f.extra.indexOf('neu') > -1 && c.dataset.new !== '1') return false;
      if (f.extra.indexOf('bestseller') > -1 && c.dataset.best !== '1') return false;
      if (st.max != null && +c.dataset.price > st.max * 100) return false;
      return true;
    }
    function apply() {
      var n = 0;
      cards.forEach(function (c) { var v = ok(c); c.hidden = !v; if (v) n++; });
      cards.slice().sort(sorter[st.sort] || sorter.beliebt).forEach(function (c) { grid.appendChild(c); });
      var cnt = $('[data-jm-count]', root); if (cnt) cnt.textContent = n === 1 ? '1 Produkt' : n + ' Produkte';
      var em = $('[data-jm-empty]', root); if (em) em.hidden = n > 0; grid.hidden = n === 0;
      var active = Object.keys(st.f).reduce(function (a, k) { return a + st.f[k].length; }, 0) + (st.max != null ? 1 : 0);
      var fb = $('[data-jm-filter-toggle] span', root); if (fb) fb.textContent = active ? 'Filter (' + active + ')' : 'Filter';
    }
    $$('[data-jm-chip]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-group'), v = b.getAttribute('data-value'), arr = st.f[g], i = arr.indexOf(v);
        if (i > -1) arr.splice(i, 1); else arr.push(v);
        b.setAttribute('aria-pressed', i > -1 ? 'false' : 'true'); apply();
      });
    });
    if (range) range.addEventListener('input', function () {
      var v = +range.value; st.max = v >= maxAll ? null : v;
      if (out) out.textContent = 'bis ' + fmt(v * 100); apply();
    });
    var sortSel = $('[data-jm-sort]', root);
    if (sortSel) sortSel.addEventListener('change', function () { st.sort = sortSel.value; apply(); });
    $$('[data-jm-reset]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        Object.keys(st.f).forEach(function (k) { st.f[k] = []; }); st.max = null; st.q = '';
        $$('[data-jm-chip]', root).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        if (range) { range.value = range.max; if (out) out.textContent = 'bis ' + fmt(maxAll * 100); }
        $$('[data-jm-search] input[name="q"]').forEach(function (i) { i.value = ''; });
        apply();
      });
    });
    var ft = $('[data-jm-filter-toggle]', root);
    if (ft) ft.addEventListener('click', function () { root.classList.toggle('jm-filters-open'); });
    root.jmSetQuery = function (q) { st.q = q; apply(); };
    apply();
  });

  $$('[data-jm-search]').forEach(function (form) {
    var input = $('input[name="q"]', form);
    form.addEventListener('submit', function (e) {
      var cat = $('[data-jm-catalog]');
      if (cat && cat.jmSetQuery) { e.preventDefault(); cat.jmSetQuery(input.value); window.scrollTo({ top: cat.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' }); }
    });
    input.addEventListener('input', function () { var cat = $('[data-jm-catalog]'); if (cat && cat.jmSetQuery) cat.jmSetQuery(input.value); });
  });
})();
